import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { closePricingModal } from "../../../../utils/close_modal";
import { getUseronboardingInfo, logOutUser } from "../../../../actions/loginActions";
import { getInitialRoute, validateUserPicture } from "../../../../utils";
import ProfileImage from "../../../CommonComponents/ProfileImage";
import { Button, Image } from "react-bootstrap";
import { MediaBaseUrl } from "../../../../actions/api";
import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";

export function QuickUser(props) {
    const dispatch = useDispatch();
    const { userData } = useSelector(state => state.authenticated, shallowEqual);
    const user = userData ? userData.user : [];
    const isPlanExceeded = props.isPlanExceeded;
    const pathname = window.location.pathname;
   
    const copyUserEmail = (id) => {
        navigator.clipboard.writeText(id);
    }

    const closeModal = (dispatch)=>{
        const { closeUgcModal, isUgcSelected} = props;
        if(isUgcSelected){
            closeUgcModal();
        }
        closePricingModal(dispatch);
    }
    return <div className="offcanvas-content">
        <div className="d-flex align-items-start mt-3">
            <div className="symbol-100 me-4 symbol-light-warning rounded position-relative">
                {user && user.picture ?
                    <ProfileImage className={'rounded overflow-hidden'}
                    imageSize={100}
                    symbolClass={'symbol-100 f-center symbol-light-warning fs-2 text-uppercase rounded'}
                    name={user.name} profileUrl={validateUserPicture(user.picture)} networkId={31} />
                    :
                    <span className="symbol-100 f-center symbol-light-warning fs-2 text-uppercase rounded">{user.name && String(user.name).length > 0 ? user.name[0] : ""}</span>}

                {user && user.isPremiumUser === 1 ? <span className="premium-user-sign">
                    <Image src={`${MediaBaseUrl}svg/icons/profile-star.svg`} className="img-fluid" alt="profile star" width={'20'} height={'20'} />
                </span> : null}
            </div>

            <div className="d-flex flex-column w-100">
                <Link to={`/profile`} className="fs-5 fw-medium text-break">{user.name}</Link>
                
                <div className="mt-2">
                    <Link to={''} className="d-flex" onClick={() => { copyUserEmail(user.emailId) }}>
                        <FontAwesomeIcon type={'solid'} icon={'envelope-dot'} iconClass={'fs-5 link-primary mt-1 me-1'}/>
                        <span className="text-muted text-break">{user.emailId}</span>
                    </Link>
                    <Button variant="secondary" onClick={()=>logOutUser()} className="whitelabelanchor fw-medium py-2 px-4 mt-3">Sign Out</Button>
                </div>
            </div>
        </div>
        <div className="separator separator-dashed my-4"></div>



        <div>
            <Link to={`/profile`} className="d-flex mb-4" onClick={() => closeModal(dispatch)}>
                <div className="f-center symbol-40 rounded bg-light text-success me-3">
                    <FontAwesomeIcon type={'duotone'} icon={'user'} />
                </div>
                <div className="">
                    <div className="fw-medium">
                        My Profile  
                    </div>
                    <div className="text-muted fs-6">
                        <small>View/Edit your personal information</small>
                    </div>
                </div>
            </Link>
            <Link to={`/notifications`} onClick={() => closeModal(dispatch)} className="d-flex mb-4">
                <div className="f-center symbol-40 rounded bg-light text-warning me-3">
                    <FontAwesomeIcon type={'duotone'} icon={'inbox'} />
                </div>
                <div className="">
                    <div className="fw-medium">
                        My Notifications
                    </div>
                    <div className="text-muted fs-6">
                        <small>All Notifications</small>
                    </div>
                </div>
            </Link>
            <Link to={`/transactions`} onClick={() => closeModal(dispatch)} className="d-flex">
                <div className="f-center symbol-40 rounded bg-light text-danger me-3">
                    <FontAwesomeIcon type={'duotone'} icon={'user-tie'} />
                </div>
                <div className="">
                    <div className="fw-medium">
                    My Account
                    </div>
                    <div className="text-muted fs-6">
                        <small>Account info, Plans and more</small>
                    </div>
                </div>
            </Link>
        </div>
        <div className="separator separator-dashed my-5"></div>
    </div>
}
